var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFachada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_19364",
    "data-name": "Group 19364",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.56,
    height: 23.024,
    viewBox: "0 0 24.56 23.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fafafa;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01_Room",
    "data-name": "01 Room",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19311",
    "data-name": "Group 19311",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7520",
    "data-name": "Path 7520",
    className: "cls-1",
    d: "M24.176,19.652a.384.384,0,0,0,.384-.384V5.454a.384.384,0,0,0-.288-.371l-11.9-3.07a.387.387,0,0,0-.192,0L.288,5.083A.384.384,0,0,0,0,5.454V20.8a.384.384,0,0,0,.266.365l5.948,1.919h0l5.948,1.919a.386.386,0,0,0,.236,0l11.9-3.837a.384.384,0,0,0,0-.729L12.663,16.687V4.3a.384.384,0,0,0-.767,0V16.687L.767,20.277V5.751L12.28,2.78,23.792,5.751V19.269A.384.384,0,0,0,24.176,19.652Zm-11.9,4.585-4.7-1.515,4.7-1.515,4.7,1.515Zm5.948-1.919-4.7-1.515,4.7-1.515,4.7,1.515ZM12.28,17.369l4.7,1.515L12.28,20.4l-4.7-1.515ZM6.332,19.288l4.7,1.515-4.7,1.515L1.634,20.8Z",
    transform: "translate(0 -2.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFachada);
export default __webpack_public_path__ + "static/media/Fachada.ed4b921cdd4cfa15c7337a0731e36864.svg";
export { ForwardRef as ReactComponent };